import { Seo } from "../components/Seo";
import { FaqAccordion } from "../components/FaqAccordion";

export default function FaqPage() {
  return (
    <main className="bg-[#F1F5F9] pt-24 sm:pt-28 min-h-screen">
      <Seo
        title="الأسئلة الشائعة | حساسات كفرات الرياض"
        description="إجابات عن أسئلة حساسات الكفرات: لمبة التحذير، عمر البطارية، الفرق بين الترددات، برمجة الحساسات البديلة، وإعادة التعلم بعد التركيب."
        path="/faq"
      />
      <FaqAccordion />
    </main>
  );
}
